import { Heart } from 'lucide-react';
import { useFavoriteStatus, useToggleFavorite } from '../../hooks/useFavorites';
import styles from './FavoriteButton.module.css';

interface FavoriteButtonProps {
  itemId: string;
  compact?: boolean;
}

export function FavoriteButton({ itemId, compact }: FavoriteButtonProps) {
  const { data } = useFavoriteStatus(itemId);
  const toggle = useToggleFavorite();

  const isFavorited = data?.isFavorited ?? false;
  const count = data?.count ?? 0;

  function handleClick(e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    toggle.mutate({ itemId, isFavorited });
  }

  return (
    <button
      className={`${styles.favBtn} ${isFavorited ? styles.favBtnActive : ''} ${compact ? styles.favBtnCompact : ''}`}
      onClick={handleClick}
      title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
    >
      <Heart
        size={compact ? 14 : 13}
        strokeWidth={1.75}
        fill={isFavorited ? 'currentColor' : 'none'}
      />
      {count > 0 && <span className={styles.count}>{count}</span>}
    </button>
  );
}
